module.exports = __webpack_public_path__ + "img/giftissue.4771b930.svg";